import { render } from "./relocationPackage.vue?vue&type=template&id=68a74e94&scoped=true"
import script from "./relocationPackage.vue?vue&type=script&lang=js"
export * from "./relocationPackage.vue?vue&type=script&lang=js"

import "./relocationPackage.vue?vue&type=style&index=0&id=68a74e94&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a74e94"]])

export default __exports__